(function () {
  let isProcessing = false;

  function wrapAED(node) {
    if (node.nodeType === 3) {
      if (/AED/.test(node.textContent)) {
        const span = document.createElement('span');
        span.dataset.aedDone = 'true';
        span.innerHTML = node.textContent.replace(
          /AED/g,
          '<span class="aed-currency">AED</span>'
        );
        node.parentNode.replaceChild(span, node);
      }
    } else if (
      node.nodeType === 1 &&
      !['SCRIPT', 'STYLE'].includes(node.tagName) &&
      !node.dataset?.aedDone
    ) {
      Array.from(node.childNodes).forEach(wrapAED);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    wrapAED(document.body);

    const observer = new MutationObserver(function (mutations) {
      if (isProcessing) return;
      isProcessing = true;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.dataset?.aedDone !== 'true') {
            wrapAED(node);
          }
        });
      });

      isProcessing = false;
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });
})();